<template>
  <data-table
    model="workflow"
    @action="doAction"
    :endpoint="endpoint"
    :route-params="{ id: $route.params.id, stepid: { key: 'uuid' } }"
    route-context="settings.workflow.edit.step"
    ref="workflowList"
  />
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { SettingsListComponent } from '@/mixins/SettingsListComponent';
import { EmitterAction } from '@/models';
import DataTable from '@/plugins/data-table/DataTable.vue';

@Component({})
export default class SettingsWorkflowList extends mixins(SettingsListComponent) {
  protected model = 'workflow';
}
</script>

<style scoped lang="scss">
</style>
